// extracted by mini-css-extract-plugin
module.exports = {"LinkButton_link":"LinkButton_link__2S5BO"};